import React, { useState } from "react";
import {
  Box,
  TextField,
  Button,
  CircularProgress,
  IconButton,
} from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";
import VariantSelect from "./VariantSelect";

interface ContactsSearchBarProps {
  initialVariantId?: string;
  onSearch: (params: { name?: string; variant_id?: string; email?: string; phone?: string }) => void;
  loading?: boolean;
}

function ContactsSearchBar({ initialVariantId = '', onSearch, loading }: ContactsSearchBarProps): React.JSX.Element {
  const [name, setName] = useState('');
  const [variantId, setVariantId] = useState(initialVariantId);
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [clearCount, setClearCount] = useState(0);

  // Auto-search on mount if initialVariantId is present
  React.useEffect(() => {
    if (initialVariantId) {
      onSearch({
        variant_id: initialVariantId || undefined,
        email: undefined,
        phone: undefined,
      });
    }
    // eslint-disable-next-line
  }, [initialVariantId]);

  const handleSearch = (e?: React.FormEvent): void => {
    if (e) e.preventDefault();
    onSearch({
      name: name.trim() || undefined,
      variant_id: variantId || undefined,
      email: email.trim() || undefined,
      phone: phone.trim() || undefined,
    });
  };

  const handleClear = () => {
    setName('');
    setVariantId('');
    setEmail('');
    setPhone('');
    setClearCount(c => c + 1);
    onSearch({});
  };

  // Auto-search when variant changes
  React.useEffect(() => {
    if (variantId !== initialVariantId) {
      onSearch({
        name: name.trim() || undefined,
        variant_id: variantId || undefined,
        email: email.trim() || undefined,
        phone: phone.trim() || undefined,
      });
    }
    // eslint-disable-next-line
  }, [variantId]);

  return (
    <Box component="form" onSubmit={handleSearch} sx={{ display: 'flex', gap: 2, mb: 3, alignItems: 'center' }}>
      <TextField
        label="שם שחיין/הורה"
        value={name}
        onChange={e => setName(e.target.value)}
        size="small"
      />
      <TextField
        label="אימייל"
        value={email}
        onChange={e => setEmail(e.target.value)}
        size="small"
      />
      <TextField
        label="טלפון"
        value={phone}
        onChange={e => setPhone(e.target.value)}
        size="small"
      />
      <VariantSelect
        value={variantId}
        onChange={setVariantId}
        label="קורס"
        clearTrigger={clearCount}
      />
      <Button type="submit" variant="contained" disabled={loading}>
        {loading ? <CircularProgress size={20} /> : 'חפש'}
      </Button>
      {(name || email || phone || variantId) && (
        <IconButton onClick={handleClear} title="נקה הכל" disabled={loading}>
          <ClearIcon />
        </IconButton>
      )}
    </Box>
  );
}

export default ContactsSearchBar; 